import { createContext } from "react";
import { GarageProperty } from "@App/apis/graphql/perimeterSearch/responses/garageProperty";

export interface AvailableFilterItem {
  id: string;
  name: string;
  disabled: boolean;
}

/**
 * Interface representing the context value for garage properties.
 */
interface GaragePropertyContextValue {
  /**
   * A list of available garage properties or null if none are available.
   */
  availableGarageProperties: GarageProperty[] | null;

  /**
   * A list of available filter items (derived from the garage properties) or null if none are available.
   * Each filter item includes an ID, name, and a disabled state.
   */
  availableFilterItems: AvailableFilterItem[] | null;
}

/**
 * React context for managing garage property-related data.
 * Provides default values of null for both available garage properties
 * and available filter items.
 */
export const GaragePropertyContext = createContext<GaragePropertyContextValue>({
  availableGarageProperties: null,
  availableFilterItems: null,
});
